var generateStyle = function generateStyle(componentTheme) {
  return {
    content: {
      margin: componentTheme.contentMargin
    },
    children: {
      paddingTop: componentTheme.childrenPadding
    }
  };
};
export default generateStyle;